import * as THREE from 'three';

let bubbleContainer = null;
let currentBubble = null;
let dismissTimer = null;

export function initSpeechBubble() {
  bubbleContainer = document.createElement('div');
  bubbleContainer.id = 'speech-bubble-container';
  bubbleContainer.style.cssText = `
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    pointer-events: none;
    z-index: 800;
    overflow: hidden;
  `;
  document.body.appendChild(bubbleContainer);
}

export function showSpeechBubble(text, worldPosition, camera, duration = 3000) {
  // Remove existing bubble if any
  hideSpeechBubble();

  // Project 3D position to screen
  const screenPos = worldPosition.clone().project(camera);

  // Don't show if behind camera
  if (screenPos.z > 1) return;

  const x = (screenPos.x * 0.5 + 0.5) * window.innerWidth;
  const y = (-screenPos.y * 0.5 + 0.5) * window.innerHeight;

  // Create bubble element
  currentBubble = document.createElement('div');
  currentBubble.style.cssText = `
    position: absolute;
    left: ${x}px;
    top: ${y - 60}px;
    transform: translateX(-50%);
    background: rgba(255, 255, 240, 0.95);
    border: 2px solid #c4a265;
    border-radius: 12px;
    padding: 8px 14px;
    font-family: 'Georgia', serif;
    font-size: 14px;
    color: #5a3e1b;
    max-width: 200px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  `;

  // Add tail via pseudo-element style
  const tailStyle = document.createElement('style');
  tailStyle.textContent = `
    #speech-bubble-tail::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 0; height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 10px solid #c4a265;
    }
    #speech-bubble-tail::before {
      content: '';
      position: absolute;
      bottom: -7px;
      left: 50%;
      transform: translateX(-50%);
      width: 0; height: 0;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-top: 9px solid rgba(255, 255, 240, 0.95);
      z-index: 1;
    }
  `;
  currentBubble.id = 'speech-bubble-tail';
  currentBubble.appendChild(tailStyle);
  currentBubble.innerHTML += `<span>${text}</span>`;

  bubbleContainer.appendChild(currentBubble);

  // Fade in
  requestAnimationFrame(() => {
    if (currentBubble) currentBubble.style.opacity = '1';
  });

  // Auto-dismiss
  dismissTimer = setTimeout(() => hideSpeechBubble(), duration);
}

export function hideSpeechBubble() {
  if (dismissTimer) { clearTimeout(dismissTimer); dismissTimer = null; }
  if (currentBubble) {
    currentBubble.style.opacity = '0';
    const bubble = currentBubble;
    currentBubble = null;
    setTimeout(() => bubble.remove(), 300);
  }
}

// Call this in the animate loop to update bubble position
export function updateSpeechBubble(worldPosition, camera) {
  if (!currentBubble) return;

  const screenPos = worldPosition.clone().project(camera);

  // Hide if behind camera
  if (screenPos.z > 1) {
    currentBubble.style.opacity = '0';
    return;
  }

  const x = (screenPos.x * 0.5 + 0.5) * window.innerWidth;
  const y = (-screenPos.y * 0.5 + 0.5) * window.innerHeight;
  currentBubble.style.left = `${x}px`;
  currentBubble.style.top = `${y - 60}px`;
  currentBubble.style.opacity = '1';
}
